import { useNotify } from '../components/notices';
import { SettingsForm } from '../components/SettingsForm';
import { PageHeading } from '../components/ui';
import { useDispatch, useSnapshot } from '../context';
import { formFromSettings, settingsPatch } from '../lib/settings';

export function SetupTab() {
  const { tournament: t } = useSnapshot();
  const dispatch = useDispatch();
  const notify = useNotify();
  return (
    <section>
      <PageHeading>Setup</PageHeading>
      <SettingsForm
        // Start again from the stored settings whenever they change (for example after undo).
        key={JSON.stringify(t.settings)}
        initial={formFromSettings(t.settings)}
        base={t.settings}
        minRounds={t.rounds.length}
        submitLabel="Save settings"
        onSubmit={(settings) => {
          const patch = settingsPatch(t.settings, settings);
          if (Object.keys(patch).length === 0) {
            notify('No changes to save.');
            return;
          }
          dispatch({ type: 'SettingsChanged', patch }, 'Settings saved.');
        }}
      />
    </section>
  );
}
